/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Scenting_Log_Grade_Kind_InvalidInputs */

const vi_error_scenting_log_grade_kind_invalid = /** @type {(inputs: Error_Scenting_Log_Grade_Kind_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại chè đặt sai ô: loại chè tấm chỉ ghi ở cột Chè tấm, loại thường ở cột Lấy hương chè, và mỗi loại chỉ một dòng trong mẻ.`)
};

/**

* @param {Error_Scenting_Log_Grade_Kind_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_scenting_log_grade_kind_invalid = /** @type {((inputs?: Error_Scenting_Log_Grade_Kind_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Scenting_Log_Grade_Kind_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_scenting_log_grade_kind_invalid(inputs)
});